function initHero(t){
    var show_nav = $(t).find('li').length >1;

    var revapi1100 = $(t).show().revolution({
        sliderType:"standard",
        jsFileLocation:"/skin/frontend/default/revolution/js/",
        sliderLayout:"fullscreen",
        dottedOverlay:"none",
        delay:9000,
        navigation: {
            keyboardNavigation:"off",
            keyboard_direction: "horizontal",
            mouseScrollNavigation:"off",
            mouseScrollReverse:"default",
            onHoverStop:"off",
            touch:{
                touchenabled:"on",
                swipe_threshold: 75,
                swipe_min_touches: 1,
                swipe_direction: "horizontal",
                drag_block_vertical: false
            }
            ,
            bullets: {
                enable:show_nav,
                hide_onmobile:true,
                hide_under:960,
                style:"zeus",
                hide_onleave:false,
                direction:"horizontal",
                h_align:"center",
                v_align:"bottom",
                h_offset:10,
                v_offset:10,
                space:5,
                tmp:'<span class="tp-bullet-image"></span><span class="tp-bullet-imageoverlay"></span><span class="tp-bullet-title">{{title}}</span>'
            }
        },
        scrolleffect: {
            blur:"on",
            maxblur:"20",
            on_slidebg:"on",
            direction:"top",
            multiplicator:"2",
            multiplicator_layers:"2",
            tilt:"10",
            disable_on_mobile:"off",
        },

        responsiveLevels:[1240,1024,778,480],
        visibilityLevels:[1240,1024,778,480],
        gridwidth:[1230,1024,778,480],
        gridheight:[800,700,700,600],
        lazyType:"none",
        parallax: {
            type:"scroll",
            origo:"slidercenter",
            speed:400,
            levels:[5,10,15,20,25,30,35,40,45,46,47,48,49,50,51,55],
            type:"scroll",
        },
        shadow:0,
        spinner:"spinner2",
        autoHeight:"off",
        disableProgressBar:"on",
        hideThumbsOnMobile:"off",
        hideSliderAtLimit:0,
        hideCaptionAtLimit:0,
        hideAllCaptionAtLilmit:0,
        debugMode:false,
        fallbacks: {
            simplifyAll:"off",
            disableFocusListener:false,
        }
    });
}